<div class="search-data" data-tour="search-panel">
    <form [formGroup]="searchDataForm" (ngSubmit)="searchClientData()">
        <div class="search-data__header">
            <span class="text-red-200 ">Datos de búsqueda</span>
            <button mat-icon-button type="button" data-testid="search-data-header-btn-close" (click)="searchState.close()"><mat-icon fontSet="material-icons-outlined">close</mat-icon></button>
        </div>
        <div class="search-data__body">
                <div class="search-data__body__form">
                    <div class="search-data__body__form__group">
                        <mat-form-field appearance="outline" class="search-data__body__form__group__tenant" data-tour="search-tenant">
                            <mat-label>Empresa</mat-label>
                            <app-select-tenants
                            toggleClassOnValue formControlName="tenant" data-testid="search-data-body-select-tenant" idOptionsPrefix="search-data-body-select-tenant-option-"></app-select-tenants>

                        </mat-form-field>
                        <mat-form-field appearance="outline" class="search-data__body__form__group__daterange" data-tour="search-daterange">
                            <mat-label>Rango de fechas</mat-label>
                            <app-horus-date-range toggleClassOnValue formControlName="dateRange" data-testid="search-data-body-date-range"></app-horus-date-range>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="search-data__body__form__group__search-value" data-tour="search-input">
                            <mat-label>Buscar por</mat-label>
                            <div class="search-data__body__form__group__search-value__container-icon-prefix" matPrefix data-tour="search-types">
                                <mat-icon fontSet="material-icons-outlined" >search</mat-icon>
                                @if (searchIcon()) {
                                    <mat-icon [svgIcon]="searchIcon()||''"></mat-icon>
                                }
                            </div>
                            <input matInput toggleClassOnValue formControlName="searchValue" data-testid="search-data-body-input-search-value" (paste)="onPaste($event)" (keyup.enter)="searchClientData()" #searchInput>
                            <button
                                mat-icon-button
                                matSuffix
                                type="button"
                                data-testid="search-data-body-btn-delete-search-value"
                                (click)="deleteSearch()">
                                <mat-icon fontSet="material-icons-outlined">close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="search-data__body__form__action">
                        <button horusBtn [disabled]="isDisabled()" (click)="searchClientData()">BUSCAR</button>
                    </div>
                </div>
                <div class="search-data__body__client-data">
                    @if (searchState.isInitialState()) {
                        <app-horus-message-general nameIcon="searchIcon">Aquí aparecerá la información del cliente.</app-horus-message-general>
                    } @else if (searchState.isLoading()) {
                        <app-horus-loading></app-horus-loading>
                    } @else if (searchState.error()) {
                        <app-horus-message-general idBtnAction="search-data-body-btn-again" nameIcon="errorIcon">Hubo un error al traer la información, inténtalo nuevamente dando click en Buscar</app-horus-message-general>
                    } @else {
                        @if (!searchState.clientData()) {
                            <app-horus-message-general idBtnAction="search-data-body-btn-create-client" nameIcon="clientNotExistIcon" btnAction="REGISTRAR CLIENTE" (action)="openClientCreationDialog()">Sin datos de cliente</app-horus-message-general>
                        } @else if (searchState.hasClientData()) {
                            <app-client-data></app-client-data>
                        }

                    }
                </div>
        </div>
    </form>
</div>
